import React from "react";
import './TruncatedHtmlTextContent.css';

export const TruncatedHtmlTextContent = ({ text, lineClamp = 1 }) => {

    const stripHtml = (html) => {
        const tmp = document.createElement("div");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    };

    return (
        <div className={`truncated-description ${'line-clamp-' + lineClamp}`}>
            {stripHtml(text)}
        </div>
    );
};